module.exports = __webpack_public_path__ + "img/mali-logo-icon.de0372db.png";